import { Layers, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useDemoMode } from "@/hooks/use-demo-mode";
import { useQueryClient } from "@tanstack/react-query";
import { useLocation } from "wouter";

export default function DemoModeBanner() {
  const { active, disable } = useDemoMode();
  const qc = useQueryClient();
  const [, setLocation] = useLocation();

  if (!active) return null;

  const handleStop = () => {
    disable();
    qc.clear();
    setLocation("/");
  };

  return (
    <div className="sticky top-0 z-40 flex items-center justify-between gap-3 border-b border-amber-500/40 bg-amber-50 dark:bg-amber-900/30 text-amber-900 dark:text-amber-100 px-4 py-2 text-sm shadow-sm">
      <div className="flex items-center gap-2 min-w-0">
        <Layers className="w-4 h-4 shrink-0 text-amber-600" />
        <span className="truncate font-medium">
          Mode démo —{" "}
          <span className="font-normal opacity-80">
            vous naviguez avec des données d'exemple. Vos données réelles ne sont pas affectées.
          </span>
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        onClick={handleStop}
        className="shrink-0 bg-white/80 hover:bg-white text-amber-900 border-amber-400 gap-1.5"
      >
        <X className="w-3.5 h-3.5" />
        Quitter la démo
      </Button>
    </div>
  );
}
